import React, { Component } from "react";
import Calendar from "react-calendar";
// Add Calendar
//import 'react-calendar/dist/Calendar.css';
import './LuLaCalendar.css';
import moment from "moment";
//import {formatDate} from "react-calendar/src/shared/dateFormatter";

const CLASS_BOOKING_OPEN = 'booking-status-open';
const CLASS_BOOKING_FULL = 'booking-status-full';
const CLASS_BOOKING_MANY = 'booking-status-many';

const DAY_STATUS_GREEN  = 1;
const DAY_STATUS_YELLOW = 2;
const DAY_STATUS_RED    = 3;

class LuLaCalendar extends Component {

  // return TRUE==CLOSED if no time-slots found that are (existing and open)
  dateIsClosed = (date) => {
    const slots = this.props.slots;
    const m = moment(date);
    const wantedDateStr = m.format('YYYYMMDD');
    //console.log( {wantedDateStr} );
    return slots.filter( x => x.dateStr === wantedDateStr  && x.isOpen).length === 0
  }

  // calc the STATUS of the passed in date
  getDayStatus = (date) => {
    const slots = this.props.slots;
    const m = moment(date);
    const wantedDateStr = m.format('YYYYMMDD');
    const daySlots = slots.filter( x => x.dateStr === wantedDateStr  && x.isOpen)

    // GREEN - has at least one green slot, ie isAvail AND NOT hasManyBookings
    const isGreen = daySlots.some( x => x.isAvailable && !x.hasManyBookings)
    if (isGreen) return DAY_STATUS_GREEN;

    // YELLOW - no green (tested above) AND at least one isAvail
    const isYellow = daySlots.some( x => x.isAvailable )
    if (isYellow) return DAY_STATUS_YELLOW;

    return DAY_STATUS_RED
  }

  handle_tileClassName = ({ activeStartDate, date, view }) => {
    //return ""; //CLASS_BOOKING_OPEN;

    // must be open
    if (!this.dateIsClosed(date)){
      const dayStatus = this.getDayStatus(date);
      if (dayStatus === DAY_STATUS_RED) {
        return CLASS_BOOKING_FULL;
      } else if (dayStatus === DAY_STATUS_YELLOW) {
        return CLASS_BOOKING_MANY;
      }
      return CLASS_BOOKING_OPEN; // open + green
    }
    return ''; // closed - no color

    //!!! for testing !!!
    //return date.getDate() === 5 ? CLASS_BOOKING_FULL : (date.getDate() === 6 ? CLASS_BOOKING_MANY : null)
  }

  // handle_tileContent = ({ activeStartDate, date, view }) => {
  //   return this.dateIsClosed(date) ? <p>Stängt</p> : null
  //   //return  view === 'month' &&  === 0 ? <p>It's Sunday!</p> : null
  // }

  handle_tileDisabled = ({ activeStartDate, date, view }) => {
    const disabled = this.dateIsClosed(date);
    //console.log({ activeStartDate, date, disabled});
    return disabled;
  }

  handle_onChange = (date) => {
    //console.log("handle_onChange: " + date + " :: " + this.props.defaultTimeValue);
    this.props.setDate(date);
    this.props.setTime(this.props.defaultTimeValue);
  }

  render() {
    const pDate = this.props.pDate;
    return (
        <div>
          {/*<h1 className='text-center'>LuLa Calendar</h1>*/}
            <div className='calendar-container'>
              <Calendar
                  //onChange={this.props.setDate}
                  onChange={this.handle_onChange}

                  //TODO: borde kanske vara första lediga tid ???
                  value={pDate}
                  //onClickDay={ (value, event) => alert('Clicked day: ', value) }
                  minDetail="month"
                  //showWeekNumbers={true}

                  // sdfsdf
                  tileClassName={  this.handle_tileClassName }
                  //tileContent={ this.handle_tileContent }
                  tileDisabled={ this.handle_tileDisabled }

                  //formatMonthYear={this.handle_formatMonthYear}
                  locale="sv-SE"
              />
            </div>
            {/*
            <p className='text-center'>
              <span className='bold'>Selected Date:</span>{' '}
              {pDate.toDateString()}
            </p>
            */}
        </div>
    );
  }
}

export default LuLaCalendar;
